import { isBrowser as e } from "./ghl-ui.es1113.js";
const t = e && "loading" in document.createElement("img");
export {
  t as isImageSupportNativeLazy
};
